module.exports = __webpack_public_path__ + "static/media/preview_white_24dp.13510c81.svg";